module.exports = __webpack_public_path__ + "img/android.f63c41ed.svg";